'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMediaSource = getMediaSource;
/**
 * MediaSource helper
 */

function getMediaSource() {
  if (typeof window !== 'undefined') {
    return window.MediaSource || window.WebKitMediaSource;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/hls.js/src/helper/mediasource-helper.js
// module id = 81
// module chunks = 0